import {
  Component,
  ElementRef,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {DevicesService, LangService, LoaderService, NavigateService} from 'ngx-satoris';
import {ZXingScannerComponent} from '@zxing/ngx-scanner';
import {ApiService} from '../../../shared/services/api.service';

@Component({
  selector: 'app-scan-qr',
  templateUrl: './scan-qr.component.html',
  styleUrls: ['./scan-qr.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ScanQRComponent implements OnInit, OnDestroy {
  @Output() scan: EventEmitter<string> = new EventEmitter<string>();
  @Output() hasStarted: EventEmitter<string> = new EventEmitter<string>();

  permissions: any;

  started: boolean;
  enable = false;
  hasPermission: boolean;
  cameraFound=false;
  autoStart = true;
  availableDevices: MediaDeviceInfo[];
  currentDevice: MediaDeviceInfo = null;
  currentCamIndex = 0;

  qrResultString: string;

  @ViewChild('zscanner', {static: false}) zscanner: ZXingScannerComponent;
  @ViewChild('scanner_wrapper', {static: false}) scanner_wrapper: ElementRef<HTMLVideoElement>;
  @ViewChild('scanner_square', {static: false}) scanner_square: ElementRef<HTMLVideoElement>;

  constructor(public nav: NavigateService,
    private api: ApiService,
    private loader: LoaderService,
    private lang: LangService,
    private device: DevicesService) {
  }

  ngOnInit(): void {
    this.loader.loading(true);
  }

  ngOnDestroy() {
    this.quitScanner();
  }

  quitScanner() {
    this.scanner_wrapper.nativeElement.remove();
    this.scanner_square.nativeElement.remove();
    this.zscanner.previewElemRef.nativeElement.remove();
    this.started = false;
    this.zscanner.scanStop();
    this.zscanner.enable = false;
    this.loader.loading(false);
  }

  onCodeResult(resultString: string) {
    this.qrResultString = resultString;
    resultString && this.scan.emit(resultString);
    const result = resultString.slice(12, 48);
    this.quitScanner();
    this.nav.to('admin-request-select/' + result, undefined, {queryParams: {from: 'scanQr'}});
  }

  onCamerasFound(devices: MediaDeviceInfo[]): void {
    this.cameraFound = true;
    this.started = true;
    this.loader.loading(false);
    this.availableDevices = devices;
    const defaultCameraIndex = this.api.getStoredItem('camera');
    if(!isNaN(defaultCameraIndex)) this.currentDevice = this.availableDevices[this.currentCamIndex];
  }

  autoStarted() {
    this.started = true;
    this.loader.loading(false);
    if(this.availableDevices?.length > 0) {
      if(this.api.getStoredItem('camera')) {
        this.currentCamIndex = this.api.getStoredItem('camera');
        this.currentDevice = this.availableDevices[this.currentCamIndex];
      }
    }
  }

  nextCamera() {
    this.currentCamIndex++;
    if(this.currentCamIndex + 1 > this.availableDevices.length) {
      this.currentCamIndex = 0;
    }
    this.currentDevice = this.availableDevices[this.currentCamIndex];
    this.api.storeItem('camera', this.currentCamIndex);
  }

  onHasPermission(permission: boolean) {
    this.hasPermission = permission;
    if(!permission && this.device.isDevices('desktop')) {
      this.loader.loading(true, {type: 'error', message: this.lang.transform('no.activecamera')}).then(() => {
        this.nav.to('dashboard');
      });
    }
    if(!permission && this.device.isDevices('cordova')) {
      this.nav.to('page-permission');
    }
  }

  camerasNotFoundHandler() {
    this.autoStart = false;
    this.loader.loading(false);
    this.cameraFound=false;
  }

  scanError(err: any) {
    this.loader.loading(true, {type: 'error', message: `ScanError: ${err}`});
  }
}
